module.exports = __webpack_public_path__ + "img/labels.5ada397f.svg";